import type { HTMLAttributes } from "react";

import { DefinedDefaults, TWithDataComponent } from "@/ui/lib";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_CONTAINER_TAGS = [ "div", "main", "section", "article", "header", "footer", "nav", "aside" ] as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

type TContainerTag = typeof AVAILABLE_CONTAINER_TAGS[number];

export type TContainerProps = {
  tag?: TContainerTag;
} & TWithDataComponent & HTMLAttributes<HTMLElement>;

type TContainerDefaultProps = DefinedDefaults<
  TContainerProps,
  "tag" | "data-component"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const CONTAINER_DEFAULTS = {
  tag: "div",
  "data-component": "Container",
} satisfies TContainerDefaultProps;
